import type { ReadConfig } from 'api-read-hook';

import { useApiRead } from 'api-read-hook';

export type V = {
  '@id': string;
  '@type': 'UserMetricSetting';
  setByUser: boolean;
  mood: boolean;
  cycleManual: boolean | null;
  symptoms: boolean;
  dailyThoughts: boolean;
  steps: boolean;
  exercise: boolean;
  sleep: boolean;
  food: boolean;
  water: boolean;
};

export type W = {
  setByUser: boolean;
  mood: boolean;
  cycleManual: boolean | null;
  symptoms: boolean;
  dailyThoughts: boolean;
  steps: boolean;
  exercise: boolean;
  sleep: boolean;
  food: boolean;
  water: boolean;
};

export function useReadItemMetricSettings(id: string, options?: ReadConfig) {
  return useApiRead<V>(`/users/${id}/metric-settings`, options);
}
